import { AnyAction } from 'redux';

const SITE_STUDY_PERSONNEL_DATA = 'SITE_STUDY_PERSONNEL_DATA';

const initialState = {
  sitestudypersonnelData: []
};

export const setSitestudypersonnelData = (dispatch: any, sitestudypersonnelData: []) => {
  dispatch({
    type: SITE_STUDY_PERSONNEL_DATA,
    data: sitestudypersonnelData
  });
};

const sitestudypersonnelDataReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SITE_STUDY_PERSONNEL_DATA: {
      return {
        ...state,
        sitestudypersonnelData: action.data
      };
    }
    default:
      return state;
  }
};

export default sitestudypersonnelDataReducer;
